import SwitchPlus from './SwitchPlus.vue';

SwitchPlus.install = (Vue) => {
  Vue.component(SwitchPlus.name, SwitchPlus);
};

export default SwitchPlus;
